import React, { useEffect, useState } from 'react';
import { Tab, Table, Tabs } from 'react-bootstrap';
import axios from "axios";
import Fuse from "fuse.js"; // Import Fuse.js
import { endPoints } from "../../Constants";
import { useTranslation,Trans  } from 'react-i18next';
const Stakeholder = () => {
    const [tabData, setTabData] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState({}); // To store filtered data per tab
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const token = localStorage.getItem('token');
        axios
            .get(`${endPoints.resource}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((res) => {
                setTabData(res.data);
                setFilteredData(res.data); // Initialize filtered data with all resources
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    const getTabTitle = (key) => {
        switch (key) {
            case 'processes':
                return t('processesTab');
            case 'government GRs/Circulars':
                return t('governmentTab');
            case 'model Drafts':
                return t('modelDraftsTab');
            case 'others':
                return t('othersTab');
            default:
                return key;
        }
    };

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value.trim()) {
            const fuse = new Fuse(Object.entries(tabData).flatMap(([key, documents]) =>
                documents.map((doc) => ({ ...doc, tabKey: key }))
            ), {
                keys: ['supportDocName'], // Search by document name
                threshold: 0.3, // Lower value = stricter match
            });

            const searchResults = fuse.search(value).reduce((acc, result) => {
                const { tabKey } = result.item;
                if (!acc[tabKey]) acc[tabKey] = [];
                acc[tabKey].push(result.item);
                return acc;
            }, {});

            // Ensure all tabs are retained, even if they have no matches
            const updatedData = Object.fromEntries(
                Object.keys(tabData).map((key) => [key, searchResults[key] || []])
            );

            setFilteredData(updatedData);
        } else {
            setFilteredData(tabData); // Reset to full data if search is cleared
        }
    };

    return (
        <section className='lyt-section typ-themebg' id='resholist'>
            <div className='container'>
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="serach-bar" data-aos="fade-in" data-aos-delay="300">
                            <input
                                type="text"
                                placeholder={t('searchBy')}
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </div>
                    </div>
                </div>

                <div className='heading-wrapper justify-content-center'>
                    <div className='text-center'>
                        <h2 className='bs-heading typ-32 typwhite mb-2' data-aos="fade-in" data-aos-delay="200">
                          { t('stakeholderResourceTitle')}
                        </h2>
                    </div>
                </div>

                <div className="bs-tab typ-resource-tab">
                    <Tabs defaultActiveKey={Object.keys(filteredData)[0]} id="dynamic-tabs" className="mb-3">
                        {Object.entries(filteredData).map(([key, documents]) => (
                            <Tab eventKey={key} title={getTabTitle(key)} key={key}>
                                <div className='typ-content-table'>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>{t('documents')}</th>
                                                <th>{t('link')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documents.length > 0 ? (
                                                documents.map((doc, index) => (
                                                    <tr key={index}>
                                                        <td>{ i18n.language==='mr'? doc.supportDocNameMr: doc.supportDocName || "Unnamed Document"}</td>
                                                        <td>
                                                            <a
                                                                href={doc.supportDocPath || "#"}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {t("DownloadPDF")}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2">No documents found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>
                        ))}
                    </Tabs>
                </div>
            </div>
        </section>
    );
};

export default Stakeholder;
